<template>
  <div class="container" :style="customStyle">
    <div class="inner-container" @mouseover="hover = true" @mouseleave="hover = false" @click="openKeywordsModal">
      <div v-if="keywords.length === 0">
        <span   class="text">+ Add Keywords</span>
      </div>
      <div v-else class="keyword-contain">
        <span class="text--keywords">Contains keywords</span>
        <div class="keyword-container">
          <div v-for="keyword in keywords" :key="keyword" class="list-words">
            <span class="keyword">{{ keyword }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showKeywordsModal" class="modal-wrapper">
      <keywords-modal :route="route ? route : {}" @onSave="handleSave" @onCancel="closeKeywordsModal" />
    </div>
  </div>
</template>

<script>
import KeywordsModal from './KeywordsModal';

export default {
  name: 'TextFlowCard',
  components: { KeywordsModal },
  props: {
    type: String,
    title: String,
    text: String,
    customStyle: String,
    onClick: Function,
    onRemove: Function,
    route: Object,
    saveKeywords: Function
  },
  computed: {
    textData ()
    {
       

         return this.type ? "text" :  "notext"
    }
  },
  
  data: () => ({
    hover: false,
    keywords: [],
    showKeywordsModal: false
  }),
  mounted() {
  
            if(this.route)
        {
          this.keywords = this.route.keywords.length > 0 ? this.route.keywords : [];
        }
    else
    {
      this.keywords =   [];
    }

  },
  methods: {
    /**
     * Open Keywords modal
     * @returns {boolean}
     */
    openKeywordsModal() {
                              return (this.showKeywordsModal = true);






    },
    /**
     * Close Keywords modal without saving the keywords
     * @returns {boolean}
     */
    closeKeywordsModal() {
      return (this.showKeywordsModal = false);
    },
    handleSave(event) {
                               this.keywords = event.keywords;  console.log(event)
      return this.$emit('save-keywords', event);
    }
  }
};
</script>

<style scoped lang="scss">
.keyword-contain {
  width: 260px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.keyword-container {
  max-width: 260px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  overflow: hidden;
}
.keyword {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.container {
  width: 320px;
  height: 80px;
  background-color: #fafbfc;
  box-shadow: 0px 2px 10px rgba(83, 95, 119, 0.15), 0px 2px 10px rgba(83, 95, 119, 0.15);
  border-radius: 5px;
  cursor: pointer;
  overflow: hidden;
  .inner-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    letter-spacing: -0.02em;
    color: $colorText;
  }
  .text {
    font-weight: 500;
    font-size: 19px;
    line-height: 20px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #008629;
    &--keywords {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.02em;
      color: #98a0ad;
      text-align: start;
    }
  }
}
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}
.list-words {
  height: 30px;
  background-color: #98a0ad;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  padding: 6px 5px;
  margin: 3px 2px;
  color: #fff;
  align-items: center;
}
.list-words:hover {
  /*box-shadow: 0 0 5px rgba(0, 149, 232, 1);*/
  border: 3px solid rgba(0, 149, 232, 1);
  border-radius: 8px;
}
</style>
